import { queryOptions } from "@tanstack/react-query";
import {
  AllScheduleForm,
  QueryToggleOptions,
  ScheduleDetailForm,
} from "shared/types";
import {
  searchSchedulesV2,
  getScheduleV2Detail,
  getAvailableCustomersByScheduleV2,
} from "hooks/api/schedule-v2";

export const searchSchedulesV2Options = (form: AllScheduleForm) =>
  queryOptions({
    queryKey: [
      "schedule-v2",
      form.start_date,
      form.type,
      form.instructor_ids,
      form.customer_ids,
      form.class_ids,
      form.include_cancelled,
    ],
    queryFn: () => searchSchedulesV2(form),
  });

export const scheduleV2DetailOptions = (form?: ScheduleDetailForm) =>
  queryOptions({
    queryKey: ["schedule-v2", form?.schedule_id, form?.occurrence_timestamp],
    queryFn: () => getScheduleV2Detail(form!),
    enabled: !!form?.schedule_id && !!form?.occurrence_timestamp,
  });

export const availableCustomersByScheduleV2Options = (
  form?: ScheduleDetailForm,
  options?: QueryToggleOptions,
) =>
  queryOptions({
    queryKey: [
      "schedule-v2",
      "available-customers",
      form?.schedule_id,
      form?.occurrence_timestamp,
    ],
    queryFn: () => getAvailableCustomersByScheduleV2(form!),
    enabled:
      !!form?.schedule_id &&
      !!form?.occurrence_timestamp &&
      (options?.enabled ?? true),
  });
